import { Component, OnInit, effect } from '@angular/core';
import { Step } from '@shared/models/cierreTurno/Step';
import { CierreDiarioService } from '../services/cierre-diario.service';
import { CierreTurno } from '@shared/models/cierreTurno/CierreTurno';

@Component({
  selector: 'app-cierre-nav-bar',
  templateUrl: './cierre-nav-bar.component.html',
  styleUrls: ['./cierre-nav-bar.component.scss']
})
export class CierreNavBarComponent implements OnInit {

  steps: Step[] = [];
  cierre: CierreTurno;
  currentStepIndex;
  progressWidth = '0%';

  constructor(public cierreDiarioService: CierreDiarioService) { 
    effect(() => { console.log('loading: ', cierreDiarioService.loading()) });
  }

  ngOnInit(): void {
    this.currentStepIndex = 0;
    this.cierreDiarioService.steps$.subscribe(steps => {
      this.steps = steps;
      this.progressWidth = `${((this.currentStepIndex + 1) / this.steps.length) * 100}%`;
    });
    this.cierreDiarioService.cierre$.subscribe(cierre => {
      this.cierre = cierre ?? null;
    })
    this.cierreDiarioService.index$.subscribe(index => {
      this.currentStepIndex = index;
    })
  }

  cambiarEtapa(index) {
    this.cierreDiarioService.changeStepProgress(index);
  }

  deshabilitarEtapa(index) {
    if(this.cierre) {
      const etapaActual = this.cierre.etapaActual ?? 0;
      if (etapaActual < index) {
        return true;
      } else return false;
    } else return true;
  }
    

}
